module.exports = __webpack_public_path__ + "static/media/p2.f556a09d.jpg";